<script>
import Config from '@/config';
import {inAppBrowser} from '@/libs/util';
import {Toast, Field, Button} from 'vant';
import {rechargeTemplate, recharge} from '@/api';

export default {
  mixins: [],
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
  },
  data() {
    return {
      money: null,
      loading: false,
      disabled: true,
      rechargeTemplates: []
    };
  },
  watch: {
    money(value) {
      this.disabled = !value;
    }
  },
  mounted() {
    window.document.title = '速电通-账户充值';

    rechargeTemplate().then(response => {
      if (response.data.code === Config.successCode) {
        this.rechargeTemplates = this.chunk(response.data.body, 2);
      }
    });
  },
  methods: {
    toRechargeAgreement() {
      this.$router.push({name: 'agreement'});
    },
    chunk(arr, size) {
      return Array.from({length: Math.ceil(arr.length / size)}, (v, i) => arr.slice(i * size, i * size + size));
    },
    optionClick(money) {
      this.money = money;
      this.disabled = false;
    },
    pay() {
      if (this.money == null || this.disabled) {
        return;
      }

      let subPlatform, client = inAppBrowser();
      if (client === 'wx') {
        subPlatform = 'WXPay.jsPay';
      } else if (client === 'alipay') {
        subPlatform = 'trade.jsPay';
      } else {
        subPlatform = 'acp.jsPay';
      }

      this.loading = this.disabled = true;
      recharge(this.money, subPlatform).then(response => {
        if (response.data.code === Config.successCode) {
          window.location.href = response.data.body;
        } else {
          Toast.fail(response.data.message);
        }
      }).catch(error => {
        Toast.fail('订单下单失败');
      }).finally(() => {
        this.loading = this.disabled = false;
      });
    }
  }
}
</script>

<template>
  <div id="recharge">
    <div class="label">选择金额</div>
    <div class="options" v-for="(items, index) in rechargeTemplates" :key="index">
      <div v-for="(item, key) in items" :key="key" @click="optionClick(item.recharge)" class="option" :class="{active: item.recharge.toString() === money}">
        {{ item.recharge }}元{{ item.give ? '(送' + item.give + '元)' : '' }}
      </div>
    </div>
    <div class="label field">充值金额</div>
    <div class="money-field">
      <van-field type="number" label="￥" placeholder="请输入充值金额" label-width="24px" autocomplete="off" clearable v-model="money"/>
    </div>
    <div class="agreement">
      <div>点击立即充值即表示你已阅读并同意</div>
      <div class="link" @click="toRechargeAgreement">《充值协议》</div>
    </div>
    <div class="submit-button">
      <van-button round block color="#009251" loading-text="处理中..." :disabled="disabled" :loading="loading" @click="pay">立即充值</van-button>
    </div>
  </div>
</template>

<style scoped>
#recharge .label {
  color: #333333;
  font-size: 16px;
  font-weight: bold;
  padding: 12px 12px 6px 12px;
}

#recharge .options {
  display: flex;
  padding-left: 6px;
  padding-right: 6px;
}

#recharge .options .option {
  width: 50%;
  margin: 6px;
  height: 64px;
  color: #333333;
  font-size: 16px;
  font-weight: bold;
  line-height: 64px;
  border-radius: 8px;
  text-align: center;
  background-color: #F8F8F8;
}

#recharge .options .option.active {
  color: white;
  background-color: #009251;
}

#recharge .label.field {
  margin-top: 6px;
  padding-bottom: 0;
}

#recharge .money-field {
  padding-right: 12px;
  --cell-font-size: 20px;
  --cell-font-weight: bold;
  --cell-horizontal-padding: 12px;
  --field-input-text-color: #333333;

  --field-placeholder-text-size: 12px;
  --field-placeholder-text-weight: 400;
  --field-placeholder-text-color: #C2C2C2;
}

#recharge .agreement {
  display: flex;
  padding: 0 12px;
  color: #333333;
  font-size: 12px;
  font-weight: 500;
  margin-top: 24px;
  justify-content: center;
}

#recharge .agreement .link {
  color: #009251;
}

#recharge .submit-button {
  padding: 6px 24px 0 24px;


}

#recharge .submit-button .van-button {
  box-shadow: 0 3px 6px 1px rgba(0, 146, 81, 0.41);
}
</style>